import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapContainer = React.lazy(function () {
    return import('../../bootstrap-components/components/BTListContainer');
});
var bootStrapContainer = function (props) {
    return (React.createElement(BootStrapContainer, __assign({}, props)));
};
export var FormErrorContainers = function (props) {
    var componentToDisplay = bootStrapContainer(props);
    //console.log('********************************** this is list container no bt*******************',props)
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
var lists = ['To Date should be greater than From Date',
    'All fields are Mandatory',
    'Only 10 digits are allowed',
    'Maximum length upto 50 characters',
    'Only integers are allowed',
    'Only letters are allowed',
    'aa', 'bbb', 'cc', 'ddd', 'ee', 'ff', 'gg', 'hh', 'ii', 'jj', 'kk', 'll'
];
FormErrorContainers.defaultProps = {
    liststyletype: 'disc',
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light'
};
//# sourceMappingURL=ListContainer.js.map